const resources = {
    seeMore: 'See more reviews that mention',
    modalTitle: 'Highly Rated by Customers for'
};

export default function getResource(label) {
    return resources[label];
}
